import React, { useEffect, useState } from "react";
import { RaceDTO } from "../../../interfaces/RaceDTO";
import UserTypChooice from "../../Tools/UserTypChooice";
import { useClock } from "../../../services/ClockProvider";
import { useBlade } from "../../../services/BladeProvider";
import ResultFooter from "../ResultFooter";
import { ViewProp, ViewType } from "../../../interfaces/internal/ViewProps";
import ResultHeader from "../ResultHeader";
import MobileResultHeader from "./MobileResultHeader";
import "../styles/mraceapp.css"
import ResultBlade from "../resultviews/ResultBlade";
import MobileResultTabs from "./MobileResultTabs";
import { UserTypes } from "../../../interfaces/internal/UserType";
import { AthleteDTO } from "../../../interfaces/AthletesDTO";
import { eventBus } from "../../../services/eventHandler";
interface Props {
  raceid: number;
  race: RaceDTO;
}
const MobileResultPages = ({ raceid, race }: Props) => {
  const [showUserType, setShowUserType] = useState<boolean>(false);
  const [classId, setClassId] = useState<number>(-1);

  const { blades,registrateRaceID, getUserType,removeBlade,addBlade,setFocusedBlade,addBlades } = useBlade();

  const { setRaceIDClock } = useClock();
  const handleBladeonCloseChanged = (id: number) => {
    removeBlade(id);
  };
  useEffect(() => {
    registrateRaceID(race.Id);
    const handlerTvFollow = (ath: AthleteDTO | null) => {
      let styleElement = document.getElementById("web-tv-follow-style");
      if (styleElement) {
        styleElement.textContent =
          ath === null
            ? ""
            : `[data-athleteid="${ath.ID}"] { background: rgba(255, 255, 0, 0.7)  !important; }`;
      }
    };

    eventBus.on(`tvfollow`, handlerTvFollow);
    setRaceIDClock(raceid);
    if (localStorage.getItem("saved_race_" + raceid) !== null) {
      let ava = JSON.parse(localStorage.getItem("saved_race_" + raceid)!);
      try {
        loadFromLocalStorage(ava["blade"]);
      } catch (error) {
        console.log(error);
      }

      // loadFromLocalStorage(!))
    }
    return () => {
      // Cleanup to avoid memory leaks
      eventBus.removeListener("tvfollow", handlerTvFollow);
    };
  }, []);
  const loadFromLocalStorage = (bladePro: ViewProp[]) => {
    // return ;
    const arrs: ViewProp[] = [];
    const blades: ViewProp[] = [];
    bladePro.forEach((data) => {
      const viwProp2: ViewProp = {
        id: data.id,
        name: data.name,
        Vtype: data.Vtype,
        color: data.color,
        order: data.order,
        width: null,
        height: null,
        autoOpened: data.autoOpened,
        classId: data.classId,
        level: data.level,
        ipos: data.ipos,
        athleteid: data.athleteid,
        maximized:false,
        fullheight: true,
        heightprocent: "100%",
        focused: data.focused,
        hideMenu: data.hideMenu
      };
      blades.push(viwProp2);
      arrs.push(viwProp2);
    });
    addBlades(blades);
  };

  const handleClassChange = (
    clasId: number,
    level: number,
    maximized: boolean,
    fullheight: boolean
  ) => {

    if (classId === clasId) {
      return;
    }
    maximized = false;
    fullheight = true;
      let tagId: number = Math.max(...blades.map((o) => o.id)) + 1;
      let tagOrder: number = Math.max(...blades.map((o) => o.order)) + 1;
  
      if (tagId === -Infinity) {
        tagId = 1;
      }
      if (tagOrder === -Infinity) {
        tagOrder = 1;
      }
      
      setClassId(clasId);
      let vie= blades.filter(o => o.autoOpened);
      console.log(vie);
      vie.map((bla) => {
        handleBladeonCloseChanged(bla.id);
      });
      if (blades.length > 0){
        tagOrder = Math.max(...blades.map((o) => o.order)) + 1;
      }
      const classData = race?.Class;
      if (classData && clasId in classData) {
        const levelData = classData[clasId].Level;
        if (levelData && level in levelData) {
          let Tposes = levelData[level].TimePos;
          let Order: number = tagOrder; //1;
          let arrs: ViewProp[] = []; // views.filter(o => !o.autoOpened); // [];
          if (getUserType() === UserTypes.TvCommentator || getUserType() === UserTypes.TvSpotter){
            
            const viProp2: ViewProp = {
              id: tagId,
              order: Order,
              name: "",
              Vtype: ViewType.athletebioTV,
              color: "black",
              width: null,
              height: null,
              autoOpened: true,
              athleteid: null,
              maximized: false,
              classId: classId,
              level: level,
              ipos: 0,
              fullheight: true,
              heightprocent:  "100%",
              focused: false,
            };
            // setViews(prevViews => [...prevViews, viProp2]);
            addBlade(viProp2);
            arrs = arrs.concat(viProp2);
            Order +=1;
            tagId += 1;
          }
          
          const viProp2: ViewProp = {
            id: tagId,
            name: "",
            Vtype: ViewType.resultPretime,
            color: "black",
            order: Order,
            width: null,
            height: null,          
            autoOpened: true,
            classId: clasId,
            level: 1,
            ipos: 0,
            athleteid: null,
            maximized: maximized,
            fullheight: fullheight,
            heightprocent: fullheight ? "100%" : "50%",
            focused: false,
          };
          // setViews(prevViews => [...prevViews, viProp2]);
          addBlade(viProp2);
          setFocusedBlade(viProp2.id);
          arrs = arrs.concat(viProp2);
          Object.keys(Tposes).map((key) => {
            let usType = getUserType();
            if (usType === null) {
            } else if (usType.valueOf() < 3) {
              if (!Tposes[parseInt(key)].IsTvPos) {
                return null;
              }
            } else if (usType.valueOf() > 10 && usType.valueOf() < 15) {
              if (!Tposes[parseInt(key)].IsTvPos) {
                return null;
              }
            }
  
            Order += 1;
            tagId += 1;
            
            const viProp: ViewProp = {
              id: tagId,
              name: "",
              Vtype: ViewType.resultPretime,
              color: "black",
              order: Order,
              width: null,
              height: null,
              autoOpened: true,
              classId: clasId,
              level: 1,
              ipos: Tposes[parseInt(key)].Ipos,
              athleteid: null,
              maximized: maximized,
              fullheight: fullheight,
              heightprocent: fullheight ? "100%" : "50%",
              focused: false,
            };
            addBlade(viProp);
            arrs = arrs.concat(viProp);
          });
        }
      }
  };
  const handleOpenChange = (viewdat: ViewType,maximized:boolean,fullheight:boolean) => {
    let id: number = 1;
    let order: number = 1;
    if (blades.length > 0) {
      id = Math.max(...blades.map((o) => o.id)) + 1;
      order = Math.max(...blades.map((o) => o.order)) + 1;
    }
    const viProp: ViewProp = {
      id: id,
      name: "",
      Vtype: viewdat,     
      color: "black",
      order: order,
      width: null,
      height: null,
      autoOpened: false,
      classId: null,
      level: 1,
      ipos: null,
      athleteid: null,
      maximized: false,
      fullheight: fullheight,
      heightprocent: fullheight ? "100%" : "50%",
      focused: false,
    };
   
    addBlade(viProp);
    setFocusedBlade(viProp.id);
  };
  return (
    <div className="mobile-version">
      {showUserType ? (
        <UserTypChooice
          userType={getUserType() || undefined}
          onExit={() => setShowUserType(false)}
        />
      ) : null}
      <div className="result-header">
        <MobileResultHeader
          classChanged={handleClassChange}
          opennewChanged={handleOpenChange}
          race={race}
          onOpenModal={() => setShowUserType(true)}
        />
      </div>
      <div className="mobile-race-tabs">
        <MobileResultTabs  race={race}/>
      </div>
      <div className="mobile-race-container" data-user={getUserType()}>
        <div className="race-app">
          <div className="race-app-inner">
            
          {blades.map((vie) =>
              vie === null || race === null ? (
                <></>
              ) : (
                <ResultBlade
                  key={`${vie.id.toString()}`}
                  id={vie.id}
                  vType={vie.Vtype}
                  vwindoprop={vie}
                  onClose={handleBladeonCloseChanged}
                  race={race}
                  timeScroll={null}
                />
              )
            )}
          </div>
        </div>
      </div>
      <div className="result-footer">
        <ResultFooter onOpenModal={() => setShowUserType(true)} />
      </div>
    </div>
  );
};

export default MobileResultPages;
